import React from 'react';
import classNames from 'classnames';
import cn from './styles.module.scss';

type LabelProps = {
  children: any;
  className?: string;
}

export function Label({ children, className }: LabelProps) {
  return (
    <div className={classNames(cn.label, className)}>
      {children}
    </div>
  );
}
